module.exports = __webpack_public_path__ + "static/magic-aecfe47fc56dcf92ea5ec68246882aaf.svg";